import { render, staticRenderFns } from "./DashboardPreloader.vue?vue&type=template&id=49cab9d8&"
import script from "./DashboardPreloader.vue?vue&type=script&lang=js&"
export * from "./DashboardPreloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports